var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMeusDadosIconMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.90909 15H1.63636C1.46759 15 1.30573 14.933 1.18639 14.8136C1.06705 14.6943 1 14.5324 1 14.3636V1.63636C1 1.46759 1.06705 1.30573 1.18639 1.18639C1.30573 1.06705 1.46759 1 1.63636 1H12.7727",
    stroke: "#737D8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.22656 9.43182H8.30793",
    stroke: "#737D8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.22656 12.0301H7.5462",
    stroke: "#737D8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.27093 3.27942H3.22656V6.70433H6.27093V3.27942Z",
    stroke: "#737D8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7734 7.04547C13.7399 7.04547 14.5234 6.26197 14.5234 5.29547C14.5234 4.32897 13.7399 3.54547 12.7734 3.54547C11.8069 3.54547 11.0234 4.32897 11.0234 5.29547C11.0234 6.26197 11.8069 7.04547 12.7734 7.04547Z",
    stroke: "#737D8C",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9995 9.9091C14.9995 9.31839 14.7648 8.75187 14.3471 8.33418C13.9294 7.91648 13.3629 7.68182 12.7722 7.68182C12.1815 7.68182 11.615 7.91648 11.1973 8.33418C10.7796 8.75187 10.5449 9.31839 10.5449 9.9091V11.8182H11.5523L11.8176 15H13.7267L13.9921 11.8182H14.9995V9.9091Z",
    stroke: "#737D8C",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeusDadosIconMenu);
export default __webpack_public_path__ + "static/media/meus-dados-icon-menu.810473ca62a66fbbb393712fbd8efa4e.svg";
export { ForwardRef as ReactComponent };